import { useTrPredefinedRoleDescription as e } from "../enums/useTrPredefinedRoleDescription.mjs";
import { useTrPredefinedRoleName as t } from "../enums/useTrPredefinedRoleName.mjs";
import { useCallback as n } from "react";
//#region src/roles/useRoleDisplay.ts
var r = () => {
	let r = t(), i = e();
	return n((e) => {
		if (!e.is_predefined) return {
			name: e.name || e.slug,
			description: e.description
		};
		let t = e.slug, n = r(t), a = i(t);
		return {
			name: n === e.slug ? e.name || e.slug : n,
			description: a === e.slug ? e.description : a
		};
	}, [r, i]);
};
//#endregion
export { r as useRoleDisplay };
